import {REPORT_ALL_FRONTLINE_COACHES} from '/enum/records.enum';

export default {
  reportName: REPORT_ALL_FRONTLINE_COACHES,
};
